import { redirect } from "react-router-dom";

import { getProjectPath } from "@/modules/get-path";
import {
  createStatementsMutation,
  processStatementMutation,
} from "@/services/lukita/mutations";
import { accountsQuery } from "@/services/lukita/queries";
import { deleteStatements } from "@/services/lukita/statements";

export async function createStatementsAction({ request, params }) {
  const { projectSlug } = params;
  const formData = await request.formData();
  const blobsIds = formData.getAll("blobsIds");

  const account = await accountsQuery().then(({ accounts }) => accounts[0]);

  await createStatementsMutation({
    accountId: account?.id,
    projectSlug,
    blobsIds,
  });

  return redirect(getProjectPath(projectSlug));
}

export async function processStatementAction({ params }) {
  const { projectSlug, id } = params;

  const account = await accountsQuery().then(({ accounts }) => accounts[0]);

  await processStatementMutation({
    accountId: account?.id,
    projectSlug,
    id,
  });

  return redirect(`${getProjectPath(projectSlug)}?success`);
}

export async function deleteStatementsAction({ request, params }) {
  const { projectSlug } = params;
  const formData = await request.formData();
  const ids = formData.get("ids");

  await deleteStatements(projectSlug, ids.split(","));

  return redirect(`${getProjectPath(projectSlug)}?success`);
}
